/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import React from 'react';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import {
  Form,
  FormGroup,
  FormControl,
  ControlLabel,
  Col,
} from 'react-bootstrap';
import RichButton from 'loracoms/RichButton';
import FormBlock from 'loracoms/FormBlock';
import ControlTips from 'loracoms/ControlTips';
import IntlMsg from 'lorautils/intl/IntlMsg';
import ErrorSet from 'lorautils/errors/ErrorSet';
import deviceActions from 'loraactions/device';
import { isInteger } from 'lorautils/checkers/numbers';


const kTargetPatterns = [{
  pattern: /.*freq.*/i,
  target: 'frequency',
}];

const guessTarget = (message) => {
  const hit = _.find(kTargetPatterns, p => p.pattern.test(message));
  if (hit) {
    return hit.target;
  }
  return 'submit';
};

const propTypes = {
  params: React.PropTypes.object.isRequired,
  sent: React.PropTypes.object.isRequired,
  intl: React.PropTypes.any.isRequired,
  deviceId: React.PropTypes.string.isRequired,
  getParams: React.PropTypes.func.isRequired,
  sendCmd: React.PropTypes.func.isRequired,
  getTxSize: React.PropTypes.func.isRequired,
  getMacLog: React.PropTypes.func.isRequired,
};

class RxParamSetupReq extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      errors: (
        new ErrorSet()
          .add('FE_EMPTY', 'rx1droffset')
          .add('FE_EMPTY', 'rx2dr')
          .add('FE_EMPTY', 'frequency')
      ),
    };
    this.intlMsg = new IntlMsg(props.intl, 'devicedetail.macview');
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleChangeRx1DROffset = this.handleChangeRx1DROffset.bind(this);
    this.handleChangeRx2DR = this.handleChangeRx2DR.bind(this);
    this.handleChangeFrequency = this.handleChangeFrequency.bind(this);
  }

  componentWillMount() {
    const { deviceId, getParams } = this.props;
    getParams(deviceId);
  }

  componentWillReceiveProps(nextProps) {
    const { params, sent } = nextProps;
    let { errors } = this.state;

    if (params !== this.props.params) {
      if (params.status === 'success') {
        const {
          rx1droffset = '',
          rx2dr = '',
          frequency = '',
        } = params.data;
        this.setState({
          rx1droffset,
          rx2dr,
          frequency,
        });

        if (String(rx1droffset) !== '') {
          errors = errors.remove('rx1droffset');
        }
        if (String(rx2dr) !== '') {
          errors = errors.remove('rx2dr');
        }
        if (String(frequency) !== '') {
          errors = errors.remove('frequency');
        }
        this.setState({ errors });
      }
    }
    if (sent !== this.props.sent) {
      this.setState({ sentStatus: sent.status });
      if (sent.status === 'success') {
        const { deviceId, getTxSize, getMacLog } = this.props;
        getTxSize(deviceId);
        getMacLog(deviceId);
      } else if (sent.status === 'failure') {
        errors = errors.add(
          sent.error.code,
          guessTarget(sent.error.message));
        this.setState({ errors });
      }
    }
  }

  handleChangeRx1DROffset(e) {
    const rx1droffset = e.target.value.trim();
    this.setState({ rx1droffset });

    const { errors } = this.state;

    if (rx1droffset === '') {
      this.setState({ errors: errors.add('FE_EMPTY', 'rx1droffset') });
      return;
    }
    if (!isInteger(rx1droffset, { min: 0, max: 5 })) {
      this.setState({ errors: errors.add('FE_INVALID', 'rx1droffset') });
      return;
    }
    this.setState({ errors: errors.remove('rx1droffset') });
  }

  handleChangeRx2DR(e) {
    const rx2dr = e.target.value.trim();
    this.setState({ rx2dr });

    const { errors } = this.state;

    if (rx2dr === '') {
      this.setState({ errors: errors.add('FE_EMPTY', 'rx2dr') });
      return;
    }
    if (!isInteger(rx2dr, { min: 0, max: 13 })) {
      this.setState({ errors: errors.add('FE_INVALID', 'rx2dr') });
      return;
    }
    this.setState({ errors: errors.remove('rx2dr') });
  }

  handleChangeFrequency(e) {
    const frequency = e.target.value.trim();
    this.setState({ frequency });

    const { errors } = this.state;

    if (frequency === '') {
      this.setState({ errors: errors.add('FE_EMPTY', 'frequency') });
      return;
    }
    if (!isInteger(frequency, { min: 1000000, max: 1670000000 })) {
      this.setState({ errors: errors.add('FE_INVALID', 'frequency') });
      return;
    }
    this.setState({ errors: errors.remove('frequency') });
  }

  handleSubmit(e) {
    this.setState({ submitted: true });
    e.preventDefault();

    const { errors } = this.state;
    if (!errors.isEmpty()) {
      return;
    }

    const { deviceId, sendCmd } = this.props;
    const { rx1droffset, rx2dr, frequency } = this.state;
    sendCmd(deviceId, {
      rx1droffset,
      rx2dr,
      frequency,
    });
  }

  render() {
    const {
      sentStatus = '',
      rx1droffset = '',
      rx2dr = '',
      frequency = '',
      errors,
      submitted = false,
    } = this.state;

    return (
      <Form horizontal onSubmit={this.handleSubmit}>
        <FormGroup validationState={submitted && errors.has('rx1droffset') ? 'error' : undefined}>
          <Col md={3}>
            <ControlLabel bsClass="aisz-control-label">RX1 DRoffset</ControlLabel>
          </Col>
          <Col md={6}>
            <FormControl
              bsClass="aisz-form-control-f"
              value={rx1droffset}
              placeholder={this.intlMsg.msg('rxparamsetupreq.rx1droffset.placeholder')}
              onChange={this.handleChangeRx1DROffset}
            />
            <ControlTips
              show={submitted && errors.has('rx1droffset')}
              message={this.intlMsg.errorMsg(errors.get('rx1droffset'))}
              azStyle="danger"
            />
          </Col>
        </FormGroup>
        <FormGroup validationState={submitted && errors.has('rx2dr') ? 'error' : undefined}>
          <Col md={3}>
            <ControlLabel bsClass="aisz-control-label">RX2 DR</ControlLabel>
          </Col>
          <Col md={6}>
            <FormControl
              bsClass="aisz-form-control-f"
              value={rx2dr}
              placeholder={this.intlMsg.msg('rxparamsetupreq.rx2dr.placeholder')}
              onChange={this.handleChangeRx2DR}
            />
            <ControlTips
              show={submitted && errors.has('rx2dr')}
              message={this.intlMsg.errorMsg(errors.get('rx2dr'))}
              azStyle="danger"
            />
          </Col>
        </FormGroup>
        <FormGroup validationState={submitted && errors.has('frequency') ? 'error' : undefined}>
          <Col md={3}>
            <ControlLabel bsClass="aisz-control-label">RX2 Frequency</ControlLabel>
          </Col>
          <Col md={6}>
            <FormControl
              bsClass="aisz-form-control-f"
              value={frequency}
              placeholder={this.intlMsg.msg('rxparamsetupreq.rx2freq.placeholder')}
              onChange={this.handleChangeFrequency}
            />
            <ControlTips
              show={submitted && errors.has('frequency')}
              message={this.intlMsg.errorMsg(errors.get('frequency'))}
              azStyle="danger"
            />
          </Col>
        </FormGroup>
        <FormGroup>
          <Col mdOffset={3} md={6}>
            <RichButton
              status={sentStatus}
              states={[{
                status: 'default',
                label: this.intlMsg.msg('submit'),
                style: 'primary',
                type: 'submit',
              }, {
                status: 'success',
                label: this.intlMsg.msg('submit.success'),
                style: 'success',
                timer: () => this.setState({ sentStatus: '' }),
              }, {
                status: 'failure',
                label: this.intlMsg.msg('submit.failure'),
                style: 'danger',
                timer: () => this.setState({ sentStatus: '' }),
              }]}
            />
          </Col>
        </FormGroup>
        <FormGroup>
          <Col mdOffset={3} md={6}>
            <FormBlock
              show={errors.has('submit')}
              message={this.intlMsg.errorMsg(errors.get('submit'))}
              azStyle="danger"
            />
          </Col>
        </FormGroup>
      </Form>
    );
  }
}

RxParamSetupReq.propTypes = propTypes;

const mapStateToProps = state => ({
  params: state.device.getRxParamSetupReq,
  sent: state.device.sendRxParamSetupReq,
});

const mapDispatchToProps = {
  getParams: deviceActions.getRxParamSetupReq,
  sendCmd: deviceActions.sendRxParamSetupReq,
  getTxSize: deviceActions.getMacTxSize,
  getMacLog: deviceActions.getMacLog,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(RxParamSetupReq));




// WEBPACK FOOTER //
// ./src/containers/Application/coms/DeviceDetail/coms/MacView/coms/RxParamSetupReq.jsx